<div class="flightSmallReservation__cont" *ngIf="validationVm as validator">
  <app-ds-generic-card
    [space]="genericCardSpaces.None">
    <div class="travel-itinerary">
      <div class="itinerary-header">
        <div class="itinerary-header-info" (click)="showMoreInfoEvent(validator, null)">
          <div class="body-header-itineray">
            <app-ds-icon [icon]="icon.Flight1" [size]="16" *ngIf="isDepartureIcon"></app-ds-icon>
            <app-ds-icon [icon]="icon.Flight2" [size]="16" *ngIf="!isDepartureIcon"></app-ds-icon>
            <app-ds-typography 
              [fontFamily]="fontFamily.SemiBold" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="!multipleOneWayKeyActive 
                ? (titleLabel | transloco | titlecase) 
                : (titleLabel | transloco )">
            </app-ds-typography>
            <app-small-reservation-date-info [sectors]="validator?.TripOption?.Sectors"></app-small-reservation-date-info>
          </div>
          <i class="icon-expand"></i>
        </div>
  
        <div class="reference-code" *ngIf="reservationCodeValidate">
          <div class="hotel-ref">
            <app-ds-typography 
              [fontFamily]="fontFamily.Regular" 
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [text]="'PACKAGES_MODULES.PACKAGE_BOOKING.YOUR_AIR_REFERENCE_CODE' | transloco : { code: referenceCode }">
            </app-ds-typography>
          </div>
          <div class="icon-cont">
            <app-copy-to-clipboard
              [copyInfo]="referenceCode"
              [parentClass]="'text-tooltip-clipboard'">
            </app-copy-to-clipboard>
          </div>
        </div>
        <div class="itinerary-status">
          <app-status-reservation-type
            [status]="statusLabel(validationVm.Status)">
          </app-status-reservation-type>
        </div>
      </div>
      <div class="itinerary-body">
        <ng-container *ngFor="let sector of validator.TripOption.Sectors; trackBy: trackById">
          <app-simple-travel-summary
            [options]="[getSector(sector)]"
            [summaryProvider]="summaryProvider"
            (showDetailEvent)="showMoreInfoEvent(validator, getSectorNumber(sector.SectorNumber))"
            [type]="getSectorNumber(sector.SectorNumber)">
          </app-simple-travel-summary>
        </ng-container>
      </div>
    </div>
  </app-ds-generic-card>
</div>